import {EMAIL_REGEX} from '../regex'

export default function emailValidator(value){
  const result = EMAIL_REGEX.test(value)
  return result
}
